// Erwähnungen im Composer (DESIGN §3.12.7): „@“ am Wortanfang öffnet die Auswahl, gefiltert ab dem
// ersten Zeichen. Reine Funktionen, getestet in mention.test.ts.

export interface MentionMatch {
  /** Index des „@“. */
  start: number;
  /** Text zwischen „@“ und Cursor. */
  query: string;
}

const MAX_QUERY = 32;

/** Erwähnung direkt vor dem Cursor finden: „@“ am Anfang oder nach Leerraum/Klammer, ohne Leerraum danach. */
export function findMentionQuery(text: string, caret: number): MentionMatch | null {
  for (let i = caret - 1; i >= 0 && caret - i <= MAX_QUERY + 1; i -= 1) {
    const ch = text[i] as string;
    if (ch === '@') {
      const before = i === 0 ? ' ' : (text[i - 1] as string);
      if (!/[\s([{"']/.test(before)) return null;
      return { start: i, query: text.slice(i + 1, caret) };
    }
    if (/\s/.test(ch)) return null;
  }
  return null;
}

/** Ersetzt „@query“ durch „@Label “ und liefert den neuen Text samt Cursor. */
export function insertMention(
  text: string,
  match: MentionMatch,
  label: string,
): { text: string; caret: number } {
  const end = match.start + 1 + match.query.length;
  const inserted = `@${label} `;
  const next = text.slice(0, match.start) + inserted + text.slice(end).replace(/^ /, '');
  return { text: next, caret: match.start + inserted.length };
}

export interface MentionCandidate {
  label: string;
  description?: string;
}

/** Filter: Treffer am Wortanfang zuerst, dann enthaltene; leere Anfrage = alle. */
export function filterMentions<T extends MentionCandidate>(
  items: T[],
  query: string,
  limit = 8,
): T[] {
  const q = query.trim().toLowerCase();
  if (!q) return items.slice(0, limit);
  const scored = items
    .map((item) => {
      const label = item.label.toLowerCase();
      const words = label.split(/\s+/);
      const score = label.startsWith(q)
        ? 0
        : words.some((w) => w.startsWith(q))
          ? 1
          : label.includes(q) || item.description?.toLowerCase().includes(q)
            ? 2
            : -1;
      return { item, score };
    })
    .filter((entry) => entry.score >= 0);
  scored.sort((a, b) => a.score - b.score);
  return scored.slice(0, limit).map((entry) => entry.item);
}
